import useAccessTokenBootstrap from './useAccessTokenBootstrap'

export default useAccessTokenBootstrap
